import { marked } from "marked";

import type { FC } from "react";

export const Markdown: FC<{ content: string }> = ({ content }) => (
  <span
    dangerouslySetInnerHTML={{
      // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      __html: marked(content) as string,
    }}
  />
);
